export const WARNING_DISPLAY_VARIABLE_MAX_COUNT = 1000
